import { FC, useState } from 'react';
import AccountElement from '@/features/account/components/AccountElement';
import { useTranslation } from 'react-i18next';
import Mail_02_IconSolid from '@/components/icons/Mail_02_IconSolid';
import SquareLock_02_IconSolid from '@/components/icons/SquareLock_02_IconSolid';
import { Button } from '@/components/ui/button';
import ComposeIcon from '@/components/icons/ComposeIcon';
import EChangeEmailModal from '@/components/everridge/EChangeEmailModal';
import EChangePasswordModal from '@/components/everridge/EChangePasswordModal';
import EVerifyEmailModal from '@/components/everridge/EVerifyEmailModal';
import { useProfileApi } from '@/features/account/hooks/useProfileApi.ts';
import { ProfileDto } from '@/features/account/types/account-dto.ts';
import { cn } from '@/lib/utils';

type Props = {
	profile?: ProfileDto;
	isMobile?: boolean;
};

const AccountCredentials: FC<Props> = ({ profile, isMobile }) => {
	const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
	const [showChangePasswordModal, setShowChangePasswordModal] =
		useState(false);
	const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false);
	const { t } = useTranslation();

	// const emailButtons = (
	// 	<div className='flex items-center gap-4'>
	// 		<Button
	// 			variant='outline'
	// 			className='px-3.5 py-1.5'
	// 			onClick={() => setShowVerifyEmailModal(true)}>
	// 			{t('elements.buttons.verifyEmail')}
	// 		</Button>
	// 		<Button
	// 			variant='outline'
	// 			size='sm'
	// 			onClick={() => setShowChangeEmailModal(true)}>
	// 			<ComposeIcon />
	// 		</Button>
	// 	</div>
	// );

	const passwordButtons = (
		<div className='flex items-center gap-4'>
			<Button
				variant='outline'
				size='sm'
				onClick={() => setShowChangePasswordModal(true)}>
				<ComposeIcon />
			</Button>
		</div>
	);

	return (
		<div className='p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 select-none truncate'>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.account.credentials.title')}
			</h3>
			<div className='flex flex-col gap-4'>
				<AccountElement
					label={t('main.account.credentials.elements.email')}
					value={profile?.email ?? ''}
					icon={Mail_02_IconSolid}
				/>
				<AccountElement
					label={t('main.account.credentials.elements.password')}
					value={'••••••••'}
					icon={SquareLock_02_IconSolid}
					extensions={passwordButtons}
				/>
			</div>
			{showChangeEmailModal && (
				<EChangeEmailModal
					onClose={() => setShowChangeEmailModal(false)}
				/>
			)}
			{showVerifyEmailModal && (
				<EVerifyEmailModal
					onClose={() => setShowVerifyEmailModal(false)}
					isMobile={isMobile}
				/>
			)}
			{showChangePasswordModal && (
				<EChangePasswordModal
					onClose={() => setShowChangePasswordModal(false)}
					isMobile={isMobile}
				/>
			)}
		</div>
	);
};

export default AccountCredentials;
